import { useMemo } from "react";
import { object, array, string } from "yup";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.Methods]: array()
                .required()
                .min(1, 'At least one payment method is required')
                .label('Payment Methods'),

            [FormField.OtherMethods]: string()
                .nullable()
                .optional()
                .max(500)
                .label('Other Payment Methods')
        })
    ), []);

export default useValidationSchema;

